import { useState } from "react";
import FsLightbox from "fslightbox-react";
import { Link } from "react-router-dom";
import { cld, cldSrcSet } from "../../utils/cld";

const ImgProstor1 = "https://res.cloudinary.com/dxa2jevmo/image/upload/v1758315918/IMG_0696_cx8lx6.jpg"
const ImgProstor2 = "https://res.cloudinary.com/dxa2jevmo/image/upload/v1758315918/IMG_0697_a4nugz.jpg"
const ImgProstor3 = "https://res.cloudinary.com/dxa2jevmo/image/upload/v1758315918/IMG_0698_npj9ls.jpg"
const ImgProstor5 = "https://res.cloudinary.com/dxa2jevmo/image/upload/v1758315937/IMG_0695_omxthx.jpg"
const ImgProstor6 = "https://res.cloudinary.com/dxa2jevmo/image/upload/v1758315937/IMG_0692_iqsmcb.jpg"
const ImgProstor7 = "https://res.cloudinary.com/dxa2jevmo/image/upload/v1758315937/IMG_0694_z6lzw0.jpg"
const ImgProstor8 = "https://res.cloudinary.com/dxa2jevmo/image/upload/v1758315917/IMG_0699_h4etaj.jpg"
const ImgProstor9 = "https://res.cloudinary.com/dxa2jevmo/image/upload/v1758315918/IMG_0701_x2pjea.jpg"
const ImgProstor10 = "https://res.cloudinary.com/dxa2jevmo/image/upload/v1758315918/IMG_0700_fdcqyk.jpg"
const ImgProstor11 = "https://res.cloudinary.com/dxa2jevmo/image/upload/v1758315917/unnamed_oxu6e3.jpg"


const Gallery = () => {
  const [toggler, setToggler] = useState(false);
  const [activeImage, setActiveImage] = useState(1);

  const images = [
    ImgProstor1, ImgProstor2, ImgProstor3,
    ImgProstor5, ImgProstor6, ImgProstor7, ImgProstor8,
    ImgProstor9, ImgProstor10, ImgProstor11
  ];

  // Lightbox: full-resolution original, only re-encoded to WebP/AVIF at the
  // highest automatic quality - no downscaling.
  const lightboxSources = images.map((img) => cld(img, { q: "auto:best" }));

  // Grid thumbnails render up to ~500 CSS px wide, so offer 2x+ for high-DPR
  // screens and let the browser pick. Originals are 1170px, so that's the cap.
  const thumbWidths = [500, 750, 1170];

  // Podela slika u 5 redova
  const perRow = Math.ceil(images.length / 5);
  const rows = [];
  for (let i = 0; i < 5; i++) {
    rows.push(images.slice(i * perRow, (i + 1) * perRow));
  }

  const rowStyle = {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: "20px", // horizontalni i vertikalni razmak
    marginBottom: "30px",
  };

  // const imageStyle = {
  //   width: "220px",      // veće slike
  //   height: "220px",
  //   objectFit: "cover",
  //   borderRadius: "15px",
  //   cursor: "pointer",
  // };

  // The height below is what the width="500" height="500" attributes used to
  // contribute as a presentation hint. The global `img { height: auto }` added
  // for CLS outranks presentation hints, which would have let aspect-ratio take
  // over and turn the tiles square on narrow viewports - so the height is now
  // stated inline to keep them rendering exactly as before.
  const imageStyle = {
  width: "100%",
  // maxWidth: "220px",
  height: "500px",
  objectFit: "cover",
  borderRadius: "15px",
  cursor: "pointer",
};

  return (
    <>
      <section style={{ padding: "40px 20px", background: "#f9f9f9" }}>
        <div style={{ textAlign: "center", marginBottom: "50px" }}>
          <h2>Ambijent</h2>
        </div>

        {rows.map((row, rowIndex) => (
          <div key={rowIndex} style={rowStyle}>
            {row.map((img, idx) => (
              <Link
                key={idx}
                to="#"
                onClick={() => {
                  setToggler(!toggler);
                  setActiveImage(rowIndex * perRow + idx + 1);
                }}
              >
                <img
                  src={cld(img, { w: 1170, q: "auto:good" })}
                  srcSet={cldSrcSet(img, thumbWidths, { q: "auto:good" })}
                  sizes="(max-width: 767px) 90vw, (max-width: 1199px) 45vw, 500px"
                  alt={`Ambijent salona Vision Beauty ${rowIndex * perRow + idx + 1}`}
                  style={imageStyle}
                  loading="lazy"
                  decoding="async"
                  width="500"
                  height="500"
                />
              </Link>
            ))}
          </div>
        ))}

        <style>
          {`
             .fslightbox-container img {
              max-width: 100% !important;
              max-height: 100% !important;
              width: auto !important;
              height: auto !important;
              margin: auto;
              display: block;
            }
          `}
        </style>
      </section>

      <FsLightbox toggler={toggler} sources={lightboxSources} slide={activeImage} />
    </>
  );
};

export default Gallery;
